module.exports = __webpack_public_path__ + "static/media/logo.0b4e5ae7.svg";